import React from 'react'
import { Pill as ATDSPill } from '@at/design-system-elements'
import { FacetGroupName, FilterName } from '../../__generated__/fed-graphql-types'
import { ATDSTrackingCallback } from '@at/design-system-tracking'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_filterPills_FilterPill_pills_Pill } from '../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'
import { filterModalPopupDelay } from '../expandable-filter/expandable-filter'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { useFormState } from '../../forms/hocs/form.state'

interface IPillProps {
    text?: string
    pills?: ReadonlyArray<SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_filterPills_FilterPill_pills_Pill>
    onInteraction?: () => void
    filters: ReadonlyArray<FilterName>
    selectedValues?: (string | undefined)[]
    isFilterSelected?: boolean
    id?: string
    exceedsWidth?: boolean
    isUserScrolled?: boolean
    trackingCallback?: ATDSTrackingCallback
    facetGroupName?: FacetGroupName | null
}

export const Pill = ({ text, filters = [], isFilterSelected, id, facetGroupName }: IPillProps) => {
    const { toggleSearchFilter } = useSearchViewState()
    const { expandFilterGroup } = useFormState()

    const handleTrackingInteractionOpen = useATTrackInteraction({
        trackingLabel: `open-filter-pill-${facetGroupName?.replace(/_/g, '-')}`,
    })

    const handleOpen = () => {
        handleTrackingInteractionOpen()
        if (facetGroupName === null || facetGroupName === undefined) {
            toggleSearchFilter(true)
            setTimeout(() => {
                const scrollFilter = document.getElementById(filters[0])
                scrollFilter && scrollFilter.scrollIntoView({ behavior: 'instant' })
            }, filterModalPopupDelay + 1)
        } else {
            expandFilterGroup(facetGroupName)
            toggleSearchFilter(true)
            setTimeout(() => {
                const scrollFilter = document.getElementById(facetGroupName.valueOf())
                scrollFilter && scrollFilter.scrollIntoView({ behavior: 'instant' })
            }, filterModalPopupDelay + 1)
        }
    }

    return isFilterSelected ? (
        <ATDSPill
            displayType={'editable'}
            onClick={handleOpen}
            text={text}
            data-testid={`${filters.join('-')}-filter-pill`}
            data-gui={`filter-pill-${filters.join('-')}`}
            attributes={{
                'aria-label': `click-to-remove-${text}`,
                id,
            }}
        />
    ) : null
}
